// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2KjKM","right":"styles_right__3D8pq"};